import { render, staticRenderFns } from "./AdhocRuleForm.vue?vue&type=template&id=5f15c56e&scoped=true"
import script from "./AdhocRuleForm.vue?vue&type=script&lang=js"
export * from "./AdhocRuleForm.vue?vue&type=script&lang=js"
import style0 from "./AdhocRuleForm.vue?vue&type=style&index=0&id=5f15c56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f15c56e",
  null
  
)

export default component.exports